import { PictogramName } from '@cbhq/cds-common';
import { Box, Divider, VStack } from '@cbhq/cds-web/layout';

import { useSpotLightContext } from '../../providers/ApplicationsProvider';

import { DangerousNudgeCard } from './DangerousNudgeCard';

export function SpotLight() {
  const spotLight = useSpotLightContext();
  if (!spotLight) return null;
  return (
    <VStack>
      <Box padding={2}>
        <DangerousNudgeCard
          testID="SpotLight"
          title={spotLight.application.label}
          description={spotLight.description}
          image={spotLight.application.illustrationUrl as PictogramName}
          href={spotLight.application.destinationUri}
        />
      </Box>
      <Divider />
    </VStack>
  );
}
